import ExpiredState from '@/app/Survey/model/ExpiredState';
import BaseService from './BaseService';

export default class TransactionService extends BaseService {
    public async getSurveyExpiredState(transactionId: number): Promise<ExpiredState> {
        const response = await this.client.get<ExpiredState>(`/transaction/${transactionId}/is-expired`);
        return response.data;
    }
}
